import React from 'react';
import { Helmet } from 'react-helmet-async';
const publicUrl = process.env.PUBLIC_URL;
const AboutUs = ({ title, description }) => {
  return (<><Helmet>
    <title>{title || 'About Us - EnbyBase Official Website'}</title>
    <meta name="description" content={description || 'Introduction of EnbyBase • TransBase'} />
    <meta property="og:title" content={title || 'About Us - EnbyBase Official Website'} />
    <meta property="og:description" content={description || 'Introduction of EnbyBase • TransBase'} />
  </Helmet>
    <div className="aup-about-us">
      <header className="aup-about-us-header">
        <h1>About Us</h1>
      </header>

      <section className="aup-about-us-description">
        <h2>Who We Are</h2>
        <p>
        EnbyBase is a dedicated space, resource hub and online community for non-binary and LGBTQ+ individuals.
        On EnbyBase Alliance, we offer a wide range of services and platforms to support and engage our community.
        We have authentic innovations like never before, including a full-stack built official website, 
        our loyalty programme EMI with miles and rewards, multilingual support with channels specifically focused on regions such as Israel and other parts of Asia.
        </p>
      </section>

      <section className="aup-about-us-platforms">
        <h2>Our Platforms</h2>
        <div className="aup-platform-list">
          <a href="https://discord.com/invite/BbJzKzCXkD" className="aup-platform-item" target="_blank" rel="noopener noreferrer">
            <img src={`${publicUrl}/favicon-512x512.jpg`} alt="Discord" className="aup-platform-logo" />
            <h3>EnbyBase Discord</h3>
          </a>
          <a href="https://discord.com/invite/jP3a3hbXer" className="aup-platform-item" target="_blank" rel="noopener noreferrer">
            <img src={`${publicUrl}/android-chrome-512x512-tb.png`} alt="Reddit" className="aup-platform-logo" />
            <h3>TransBase Discord</h3>
          </a>
          <a href="https://reddit.com/r/enbybase" className="aup-platform-item" target="_blank" rel="noopener noreferrer">
            <img src="https://firebasestorage.googleapis.com/v0/b/enbybase.appspot.com/o/cdn1%2Freddit-icon-512x512-mp8wosd1.png?alt=media&token=9800dafc-4168-4360-bf60-38825a5f1dc9" alt="Twitter" className="aup-platform-logo" />
            <h3>EnbyBase Subreddit</h3>
          </a>
          <a href="https://reddit.com/r/transbase" className="aup-platform-item" target="_blank" rel="noopener noreferrer">
            <img src="https://firebasestorage.googleapis.com/v0/b/enbybase.appspot.com/o/cdn1%2Freddit-icon-512x512-mp8wosd1.png?alt=media&token=9800dafc-4168-4360-bf60-38825a5f1dc9" alt="Telegram" className="aup-platform-logo" />
            <h3>TransBase Subreddit</h3>
          </a>
          <a href="https://youtube.com/@enbybase" className="aup-platform-item" target="_blank" rel="noopener noreferrer">
            <img src="https://firebasestorage.googleapis.com/v0/b/enbybase.appspot.com/o/cdn1%2F1384060.png?alt=media&token=75876bb4-7fa1-4751-a34d-0c8646c8bdba" alt="Twitter" className="aup-platform-logo" />
            <h3>EnbyBase YouTube</h3>
          </a>
          {/* Add more platform links here as necessary */}
        </div>
      </section>

      <section className="aup-about-us-contact">
        <h2>Contact Us</h2>
        <p>If you have any questions or inquiries, feel free to reach out to us at <a href="mailto:enbybase@gmail.com">enbybase@gmail.com</a>.</p>
      </section>
    </div></>
  );
};

export default AboutUs;
